import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Route, Switch } from 'react-router-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { PageContainer } from 'router'

import { load } from 'features/teamlist/store/actions'
import Header from 'features/teamlist/components/header'
import TeamMembers from 'features/teamlist/components/members'

import TeamPage from './teamPage'
import ArchivePage from './archivePage'
import { getUserFromLocation, hasTeamLocationBeenUpdated } from 'utils/location'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      load
    },
    dispatch
  )
})

class TeamLayout extends PureComponent {
  constructor(props) {
    super(props)

    const routeUser = getUserFromLocation(this.props.location)
    this.props.actions.load(routeUser)
  }

  componentDidUpdate(prevProps) {
    if (hasTeamLocationBeenUpdated(prevProps, this.props)) {
      const routeUser = getUserFromLocation(this.props.location)
      this.props.actions.load(routeUser)
    }
  }

  render() {
    return (
      <div className="team-layout">
        <Header />
        <TeamMembers />
        <TransitionGroup>
          <CSSTransition
            key={this.props.location.pathname}
            timeout={{ enter: 400, exit: 400 }}
            appear={true}
            mountOnEnter={true}
            unmountOnExit={true}
            classNames={'page-transition'}>
            <PageContainer>
              <Switch location={this.props.location}>
                <Route exact path="/team" component={TeamPage} />
                <Route exact path="/team/archive" component={ArchivePage} />
              </Switch>
            </PageContainer>
          </CSSTransition>
        </TransitionGroup>
      </div>
    )
  }
}

const containerRedux = connect(
  null,
  mapDispatchToProps,
  null,
  {
    pure: true
  }
)(withRouter(TeamLayout))

export default containerRedux



// WEBPACK FOOTER //
// ./src/pages/teamlist/index.js